import { jsPDF } from 'jspdf';

export const extractFirstAndLastName = (fullName) => {
    if (!fullName) return { firstName: '', lastName: '' };
    const parts = fullName.trim().split(' ');
    const firstName = parts[0];
    const lastName = parts.length > 1 ? parts[parts.length - 1] : '';
    return { firstName, lastName };
};

export const generateBadgeCard = async (user) => {
    const { firstName, lastName } = extractFirstAndLastName(user.User.nome);
    const mainNameFinal = user.nome_cracha || (firstName + ' ' + lastName);
    const voluntarioId = user.codigo_antigo_voluntariado || user.codigo_voluntario_feesp || '00000000';

    const genero = user.User?.genero;
    const textoVoluntario = genero === 'masculino' ? 'VOLUNTÁRIO' : 'VOLUNTÁRIA';

    const userPhoto = user.foto_cracha || user.User?.imagem_perfil;
    let userPhotoUrl = null;
    if (userPhoto instanceof File) {
        userPhotoUrl = URL.createObjectURL(userPhoto);
    } else if (userPhoto) {
        userPhotoUrl = `${process.env.REACT_APP_API_KEY}/images/${userPhoto}`;
    }

    const card = document.createElement('div');
    card.style.width = '5.5cm';
    card.style.height = '8.5cm';
    card.style.backgroundImage = `url(/images/fundo_cracha_vertical_v2.png)`;
    card.style.backgroundSize = '100% 100%';
    card.style.backgroundPosition = 'center';
    card.style.backgroundRepeat = 'no-repeat';
    card.style.position = 'relative';
    card.style.fontFamily = "'DIN 2014', 'Arial Narrow', 'Roboto', sans-serif";
    card.style.overflow = 'hidden';
    card.style.boxShadow = '0 0 1px rgba(0,0,0,0.1)';
    card.style.borderRadius = '10px';

    card.innerHTML = `
        <div style="
            position: absolute;
            top: 1.22cm;
            left: 0.5cm;
            font-size: 10pt;
            font-weight: 800;
            letter-spacing: 0.01em;
            color: #5691CA;
            z-index: 2;
            line-height: 1;
        ">${textoVoluntario}</div>

        <div style="
            position: absolute;
            top: 1.84cm;
            left: 1.65cm;
            width: 2.24cm;
            height: 3.02cm;
            box-sizing: border-box;
            border: 2px solid #5691CA;
            border-radius: 16px;
            overflow: hidden;
            z-index: 2;
            ${userPhotoUrl ? `background-image: url('${userPhotoUrl}'); background-size: cover; background-position: center; background-repeat: no-repeat;` : ''}
        " class="badge-photo-container">
            <div class="badge-photo-overlay" style="
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 30%;
                background-color: rgba(0,0,0,0.25);
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                border-bottom-left-radius: 12px;
                border-bottom-right-radius: 12px;
                transition: all 0.3s ease;
            ">
                <div class="badge-action-buttons" style="
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    padding: 2px 4px;
                ">
                    <button type="button" class="badge-btn-change" style="
                        background: rgba(255,255,255,0.95);
                        border: none;
                        border-radius: 4px;
                        padding: 3px 6px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 7px;
                        font-weight: 600;
                        color: #333;
                        font-family: sans-serif;
                    " title="Escolher nova foto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="17 8 12 3 7 8"></polyline>
                            <line x1="12" y1="3" x2="12" y2="15"></line>
                        </svg>
                        <span>Alterar</span>
                    </button>
                    <button type="button" class="badge-btn-crop" style="
                        background: rgba(255,255,255,0.95);
                        border: none;
                        border-radius: 4px;
                        padding: 3px 6px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 7px;
                        font-weight: 600;
                        color: #333;
                        font-family: sans-serif;
                    " title="Ajustar enquadramento">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                            <circle cx="8.5" cy="8.5" r="1.5"></circle>
                            <polyline points="21 15 16 10 5 21"></polyline>
                        </svg>
                        <span>Ajustar</span>
                    </button>
                </div>
            </div>
        </div>

        <div style="
            position: absolute;
            top: 5.3cm;
            left: 0.5cm;
            right: 0.5cm;
            text-align: center;
            z-index: 2;
            line-height: 1.2;
        ">
            <div style="
                font-size: 11pt;
                font-weight: 800;
                text-transform: uppercase;
                word-break: break-word;
                letter-spacing: 0.02em;
                color: #000;
            ">${mainNameFinal}</div>
            <div style="
                font-size: 8pt;
                font-weight: 400;
                margin-top: 0.15cm;
                letter-spacing: 0.05em;
                color: #000;
            ">${voluntarioId}</div>
        </div>
    `;

    return card;
};

// Carrega uma imagem e resolve com o elemento <img> já pronto para o jsPDF.
const carregarImagem = (src, comCORS) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        if (comCORS) img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });

// Recorta a foto no formato "cover" (preenche a caixa sem distorcer) e
// devolve um dataURL pronto para o jsPDF.
const recortarFotoCover = (img, larguraPx, alturaPx) => {
    const canvas = document.createElement('canvas');
    canvas.width = larguraPx;
    canvas.height = alturaPx;
    const ctx = canvas.getContext('2d');

    const escala = Math.max(larguraPx / img.width, alturaPx / img.height);
    const w = img.width * escala;
    const h = img.height * escala;
    const dx = (larguraPx - w) / 2;
    const dy = (alturaPx - h) / 2;
    ctx.drawImage(img, dx, dy, w, h);
    return canvas.toDataURL('image/png');
};

// Gera e baixa o PDF de um crachá individual, desenhado DIRETO no jsPDF
// (texto vetorial + imagens em resolução nativa), sem html2pdf — evita o
// bug conhecido do html2pdf de gerar página extra em branco por
// arredondamento, e garante nitidez em qualquer resolução de impressão.
export const generateBadgeCardPdf = async (user, layout = 'vertical') => {
    const isHorizontal = layout === 'horizontal';

    const nomeCompleto = user.User?.nome || '';
    const partes = nomeCompleto.trim().split(/\s+/);
    const primeiro = partes[0] || '';
    const ultimo = partes.length > 1 ? partes[partes.length - 1] : '';
    const nomeCracha = (user.nome_cracha || `${primeiro} ${ultimo}`).trim().toUpperCase();
    const voluntarioId = user.codigo_antigo_voluntariado || user.codigo_voluntario_feesp || '00000000';
    const genero = user.User?.genero;
    const textoVoluntario = genero === 'masculino' ? 'VOLUNTÁRIO' : 'VOLUNTÁRIA';

    // Resolve a URL da foto (pode ser File novo ou arquivo já salvo no servidor).
    const fotoBruta = user.foto_cracha || user.User?.imagem_perfil;
    let fotoUrl = null;
    let fotoComCORS = false;
    if (fotoBruta instanceof File) {
        fotoUrl = URL.createObjectURL(fotoBruta);
    } else if (fotoBruta) {
        fotoUrl = `${process.env.REACT_APP_API_KEY}/images/${fotoBruta}`;
        fotoComCORS = true;
    }

    const larguraCard = isHorizontal ? 8.6 : 5.5;
    const alturaCard = isHorizontal ? 5.4 : 8.5;

    const doc = new jsPDF({
        unit: 'cm',
        format: [larguraCard, alturaCard],
        orientation: isHorizontal ? 'landscape' : 'portrait',
    });

    // 1) Fundo do crachá (borda a borda).
    const fundoSrc = isHorizontal
        ? '/images/fundo-cracha.jpg'
        : '/images/fundo_cracha_vertical_v2.png';
    try {
        const fundo = await carregarImagem(fundoSrc, false);
        doc.addImage(fundo, isHorizontal ? 'JPEG' : 'PNG', 0, 0, larguraCard, alturaCard);
    } catch (e) {
        console.error('Erro ao carregar o fundo do crachá', e);
    }

    // 2) Foto do voluntário, recortada e com cantos arredondados.
    const foto = isHorizontal
        ? { x: 0.76, y: 1.44, w: 2.47, h: 2.21, r: 0.37 }
        : { x: 1.65, y: 1.84, w: 2.24, h: 3.02, r: 0.42 };
    if (fotoUrl) {
        try {
            const img = await carregarImagem(fotoUrl, fotoComCORS);
            const dataUrl = recortarFotoCover(
                img,
                Math.round(foto.w * 160),
                Math.round(foto.h * 160)
            );
            try {
                doc.saveGraphicsState();
                doc.roundedRect(foto.x, foto.y, foto.w, foto.h, foto.r, foto.r, null);
                doc.clip();
                doc.discardPath();
                doc.addImage(dataUrl, 'PNG', foto.x, foto.y, foto.w, foto.h);
                doc.restoreGraphicsState();
            } catch (clipErr) {
                // Se o recorte arredondado falhar, coloca a foto reta.
                doc.addImage(dataUrl, 'PNG', foto.x, foto.y, foto.w, foto.h);
            }
        } catch (e) {
            console.error('Erro ao carregar a foto do voluntário', e);
        }
    }

    // 2b) Borda da foto (o fundo vertical não tem mais essa borda desenhada
    // nele — agora é sempre traçada aqui, igual à prévia em tela).
    if (!isHorizontal) {
        doc.setDrawColor(86, 145, 202);
        doc.setLineWidth(0.05);
        doc.roundedRect(foto.x, foto.y, foto.w, foto.h, foto.r, foto.r, 'S');
    }

    // 3) Textos (vetoriais — nítidos em qualquer tamanho).
    if (isHorizontal) {
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(14);
        const linhasNome = doc.splitTextToSize(nomeCracha, 4.6);
        doc.text(linhasNome, 3.5, 2.2);

        const yCodigo = 2.2 + linhasNome.length * 0.55 + 0.2;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.text(`Código do Voluntário: ${voluntarioId}`, 3.5, yCodigo);
    } else {
        // VOLUNTÁRIO/A (mesma cor azul da borda da foto)
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.setTextColor(86, 145, 202);
        doc.text(textoVoluntario, 0.5, 1.55);

        // Nome (centralizado, corpo 11 igual à prévia em tela)
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);
        // Largura um pouco maior que a caixa da prévia (4.5cm) porque a fonte
        // Helvetica do jsPDF é ligeiramente mais larga por caractere que a
        // fonte usada no navegador — sem essa folga, nomes que cabem em uma
        // linha na prévia quebram em duas no PDF.
        const linhasNome = doc.splitTextToSize(nomeCracha, 4.7);
        const yNome = 5.65;
        doc.text(linhasNome, larguraCard / 2, yNome, { align: 'center' });

        const yCodigo = yNome + linhasNome.length * 0.45 + 0.15;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.text(String(voluntarioId), larguraCard / 2, yCodigo, { align: 'center' });
    }

    const nomeArquivo = (user.User?.nome || 'voluntario')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/\s+/g, '_').toLowerCase();

    doc.save(`cracha_${nomeArquivo}.pdf`);
};
